import { render, staticRenderFns } from "./Main-Register.vue?vue&type=template&id=36d6f6a2&"
import script from "./Main-Register.vue?vue&type=script&lang=js&"
export * from "./Main-Register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports